import { crudSlice } from 'saga-slice-helpers';

import { sagaApi } from '#/apis';

const sagaSliceModule = crudSlice({
    name: 'titles',
    sagaApi
});

export const { actions } = sagaSliceModule;
export default sagaSliceModule;
